export default __webpack_public_path__ + "static/media/checked.2aeb54c6.svg";